// extracted by mini-css-extract-plugin
module.exports = {"BooksOutlineLabel":"BooksOutlineLabel_BooksOutlineLabel__1NT29"};